import React from "react";
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from "../../../components/table/TableOps";
import { Button, Dialog, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import EnviarFacturaEmail from "../Facturar/EnviarFacturaEmail";
import { DialogComponent } from "../../../components/dialog/DialogComponent";
import Http from "../../../Http";
import Snackbar from "../../../components/alert/Snackbar";
import ACCESS from "../../../ACCESS";

class FacturasCredito extends TableComponent {

  componentDidMount() {
    this.setState({
      id_motivo: 2,
      folio_relacionado: ''
    }, () => {
      this.tableConfig(
        { dataUrl: 'facturas/filter?type=2', deleteUrl: 'cotizacion/delete', deleteField: 'cliente_nombre', modUrl: '/Ventas/FacturarCredito' },
        TableOp.Table(null, [
          // { label: 'Folio', id: 'folio' },
          { label: 'Folio', id: 'tipo_cons' },
          { label: 'Folio 2da Factura', id: 'factura_relacionada' },
          { label: 'Folio Factura Copia', id: 'factura_copia' },
          { label: 'Source', id: 'source' },
          { label: 'Cliente', id: 'cliente_nombre' },
          { label: 'RFC', id: 'Rrfc' },
          { label: 'Total', id: 'total' },
          { label: 'Fecha', id: 'fecha' },
          { label: 'Estatus', id: 'estado' },
          { label: 'Timbrada', id: 'timbrada' },
          { label: 'Fecha Cance.', id: 'cancelada_fecha' },
          { label: 'Cancelacion Acuse', id: 'cancelada_acuse' },
          { label: 'Envio CYC', id: 'id_cyc_envio' },
          { label: 'Usuario', id: 'usuario' },
        ], [
          { id: 'edit', icon: 'visibility', tooltip: 'Ver factura', access: [ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_CREADAS_POR_EL_USUARIO, ACCESS.VENTAS_FACTURAS_CREDITO.VER_FACTURAS_SUCURSAL_DEL_USUARIO, ACCESS.VENTAS_FACTURAS_CREDITO.VER_TODAS_FACTURAS] },
          { id: 'cancel', icon: 'cancel', tooltip: 'Cancelar factura', cb: this.cancelarFactura, access: [ACCESS.VENTAS_FACTURAS_CREDITO.CANCELAR_FACTURA] },
          { id: 'view', icon: 'email', tooltip: 'Reenviar correo', cb: this.reenviarFactura, access: [ACCESS.VENTAS_FACTURAS_CREDITO.RE_ENVIAR_CORREO] },
          { id: 'acuse', icon: 'picture_as_pdf', tooltip: 'Descargar acuse de cancelación', cb: this.descargarAcuse, access: [ACCESS.VENTAS_FACTURAS_CREDITO.CANCELAR_FACTURA] },
        ]))
      this.table();
    })
  }

  descargarAcuse = async (id, row) => {
    try {
      Snackbar('Descargando acuse...');
      const Resp = await Http.post(`acuse-cancelacion/acuse-cancelacion-pdf`, { tipo: 'factura', id: row.id }, true, "arraybuffer");
      let response = null;
      try {
        let decodedString = String.fromCharCode.apply(null, new Uint8Array(Resp));
        response = JSON.parse(decodedString);
      } catch (error) { }
      if (response && response.error) {
        Snackbar(`Error: ${response.errMsg || 'No se pudo descargar el acuse'}`);
      } else {
        const blob = new Blob([Resp], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `Acuse_Cancelacion_${row.tipo_cons || row.folio || row.id}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        Snackbar('Acuse descargado');
      }
    } catch (error) {
      console.log(error);
      Snackbar('Error al descargar acuse');
    }
  }

  reenviarFactura = (id, row) => {
    const hasFolioFiscal = (row.FFO && typeof row.FFO === 'string' && row.FFO.trim() !== '') || (row.timbrada && row.timbrada !== 'No');
    if (!hasFolioFiscal) {
      Snackbar('No se puede enviar una factura sin Folio Fiscal');
      return;
    }
    this.setState({ reenviarDialog: { visible: true, row } });
  }

  reenviarFacturaClose = (id) => {
    this.setState({ reenviarDialog: { visible: false, row: {} } });
  }

  copiarFacturaClose = async (op) => {
    const { row } = this.state.copyDialog;
    this.setState({ copyDialog: { visible: true, loading: true, row } });
    if (op === 1) {
      await this.copyFactura(row);
      this.setState({ copyDialog: { visible: false, row: {}, loading: false } });
    }
    else {
      this.setState({ copyDialog: { visible: false, row: {} } });
    }
  }

  cancelarFactura = (id, row) => {
    this.setState({ cancelarDialog: { visible: true, row } });
  }

  copiarFactura = (id, row) => {
    this.setState({ copyDialog: { visible: true, row } });
  }

  cancelarFacturaClose = async (op) => {
    const { row } = this.state.cancelarDialog;
    this.setState({ cancelarDialog: { visible: true, loading: true, row } });
    if (op === 1) {
      await this.sendCancelarFactura(row);
      this.setState({ cancelarDialog: { visible: false, row: {}, loading: false } });
    }
    else {
      this.setState({ cancelarDialog: { visible: false, row: {} } });
    }
  }

  sendCancelarFactura = async (factura) => {
    const { id_motivo, id_factura_nueva = false, folio_relacionado } = this.state;
    try {
      let res = await Http.post(`facturacion/${factura.id}/cancelar`, {
        id_motivo,
        id_factura_nueva,
        folio_relacionado,
      });
      if (!res.error) {
        Snackbar("Factura cancelada");
        this.table();
      } else {
        Snackbar(`Error: ${res.errMsg}`);
      }
    } catch (error) {

    }
  }

  copyFactura = async (factura) => {
    try {
      let res = await Http.post(`facturacion/copiar`, {
        factura_id_original: factura.id,
      });
      if (!res.error) {
        if (res.data && res.data.error_cancelacion) {
          Snackbar(res.data.error_cancelacion);
        } else {
          Snackbar(`Factura copiada correctamente, Folio Nuevo: ${res.data.tipo_cons}`);
        }
        this.table();
      } else {
        Snackbar(`Error: ${res.errMsg}`);
      }
    } catch (error) {

    }
  }

  render() {
    const {
      reenviarDialog = { visible: false, row: {} },
      cancelarDialog = { visible: false, row: {} },
      copyDialog = { visible: false, row: {} },
      id_motivo = 2,
      folio_relacionado,
    } = this.state;
    const { hasAccess } = this.context
    return (
      <div>
        <div
          style={{
            display: "flex",
            padding: 10,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h1>Facturas</h1>
          {hasAccess(ACCESS.VENTAS_FACTURAS_CREDITO.CREAR_FACTURA) &&
            <Button
              color="primary"
              variant={"contained"}
              onClick={() => {
                this.props.history.push(`/Ventas/FacturarCredito`);
              }}
            >
              Nueva Factura
            </Button>
          }
        </div>
        <this.TableRender />


        <Dialog
          fullWidth={true}
          maxWidth={"xl"}
          open={reenviarDialog.visible}
          onClose={() => this.reenviarFacturaClose(false)}
        // onClick={() => this.reenviarFacturaClose(false)}
        >
          <DialogTitle>Reenviar factura</DialogTitle>
          <DialogContent>
            <EnviarFacturaEmail factura={reenviarDialog.row} credito />
          </DialogContent>
        </Dialog>

        <DialogComponent
          title='Cancelación de factura'
          options={['Sí, cancelar']}
          open={cancelarDialog.visible}
          onClose={this.cancelarFacturaClose}
          loading={cancelarDialog.loading}>
          <div className='row' >
            <div className='col-sm-12' >
            </div>
            <div className='col-sm-12' >
              <FormControl >
                <InputLabel>Motivo de Cancelacion</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={id_motivo}
                  onChange={(e) => { this.setState({ id_motivo: e.target.value, }) }}
                >
                  <MenuItem value={1}>01 - Comprobante emitido con errores con relación.</MenuItem>
                  <MenuItem value={2}>02 - Comprobante emitido con errores sin relación.</MenuItem>
                  <MenuItem value={3}>03 - No se llevó a cabo la operación.</MenuItem>
                </Select>
                {id_motivo === 1 ?
                  <TextField
                    variant="outlined"
                    className="form-field"
                    type={"text"}
                    label={`FOLIO FISCAL O FOLIO DE FACTURA RELACIONADO`}
                    value={folio_relacionado}
                    onChange={(e) => { this.setState({ folio_relacionado: e.target.value }) }}
                  />
                  : null
                }
              </FormControl>
            </div>
          </div>
        </DialogComponent>

        <DialogComponent
          title='Hacer una copia de la factura'
          options={['Sí, Copiar']}
          open={copyDialog.visible}
          onClose={this.copiarFacturaClose}
          loading={copyDialog.loading}>
          <div className='row' >
            <div className='col-sm-12' >
              Se va crear una copia de la factura {copyDialog.row.tipo_cons}
            </div>
          </div>
        </DialogComponent>
      </div>
    );
  }
}


export default withRouter(FacturasCredito)